import { Injectable, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';
import { IGAFormField, IGAFormItem, IGAFormMetadata } from './forms.service';

@Injectable()
export abstract class BaseCustomComponent {
  @Input() public form: UntypedFormGroup;
  @Input() public fields:{ [key:string]:IExtraFieldConfigurationObject[] };
  @Input() public metadata:IGAFormMetadata;
  @Input() public field?:IGAFormField;
  @Input() public getModelValue?: () => IGAFormItem;
}